export { Cache, ConsoleLogger, CookieStorage, Hub, I18n, ServiceWorker, defaultStorage, sessionStorage, sharedInMemoryStorage } from '@aws-amplify/core';
export { parseAmplifyConfig } from '@aws-amplify/core/internals/utils';
